import { Extension } from '@tiptap/core';

const TextUpdater = Extension.create({
  name: 'textUpdater',

  addCommands() {
    return {
      updateText: (html) => ({ tr, state, dispatch, editor }) => {
        if (!dispatch || !state) return false;

        const { from, to } = state.selection;
        if (from === to) return false;

        const duration = 100; // Время между вставками символов

        // Удаляем выделенный текст
        tr.delete(from, to);
        dispatch(tr);

        // Создаем временный элемент для разбора HTML
        const wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        
        const nodes = Array.from(wrapper.childNodes); // Преобразуем HTML в массив нод
        let currentIndex = 0;

        function removeTrailingBreaks() {
          document.querySelectorAll('.ProseMirror-trailingBreak').forEach(element => element.remove());
        }

        function insertNextNode() {
          if (currentIndex >= nodes.length) return;

          const node = nodes[currentIndex];
          
          // Вставляем содержимое каждой ноды
          if (node.nodeType === Node.TEXT_NODE) {
            editor.commands.insertContent(node.textContent);
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            editor.commands.insertContent(node.outerHTML);
          }

          currentIndex++;
          setTimeout(() => {
            insertNextNode(); // вставляем контент
            removeTrailingBreaks(); // удаляем trailingBreak
          }, 0);
        }

        // Начинаем вставку с небольшой задержкой
        setTimeout(insertNextNode, 0);

        return true;
      },
    };
  },
});

export default TextUpdater;
